/**
 * 判断基金类型
 */

class FundTypeSearch {
  static isExchangeFund(type) {
    return /.*_.*[P].*_.*/.test(type) || /.*_.*_.*E.*/.test(type);
  }

  static isHKFund(type) { // 香港基金
    return /.*H.*_.*_.*/.test(type);
  }

  static isHeighLevelFund(type) { // 高端理财
    return /.*G.*_.*_.*/.test(type);
  }

  static isNetValueHBFund(type) { // 净值型货币
    return /.*_.*JF.*_.*/.test(type);
  }

  static isNetValueLCFund(type) { // 净值型理财
    return /.*_.*JC.*_.*/.test(type);
  }

  static isNewFund(type) { // 新发基金
    return /.*_.*_.*N.*/.test(type);
  }

  static isMonetaryfund(type) { // 货币基金
    return /.*_.*[C|F].*_.*/.test(type);
  }

  static isPit(type) {
    return /.*_.*_.*E.*/.test(type);
  }

  static isClosed(type) {
    return /.*_.*P.*_.*/.test(type);
  }

  static isPaymentNotesFund(type) {
    return /.*G.*_.*K.*_.*/.test(type);
  }

  static isHQBFund(type) { // 活期宝
    return /.*_.*_.*H.*/.test(type);
  }

  static isGoldFund(type) { // 黄金基金
    return /.*_.*U.*_.*/.test(type);
  }

  static isFOFFund(type) { // FOF基金
    return /.*_.*Z.*_.*/.test(type);
  }

  static isQDIIFund(type) {
    return /.*_.*[QET].*_.*/.test(type);
  }

  static isGradeBondAFund(type) { // 分级 A
    return /.*_.*Y.*_.*/.test(type);
  }

  static isBondFund(type) { // 分级 A
    return /.*_.*[DBRMY].*_.*/.test(type);
  }
}

export default FundTypeSearch;
